import { getCommodityCorrelations } from "@/_core/data/api_calls/relatives_values/correlations/getCommodityCorrelations";
import { getCurrencyCorrelations } from "@/_core/data/api_calls/relatives_values/correlations/getCurrencyCorrelations";

/**
 * Retrieves correlation data for relative values
 * @param {object} ctx: context variables
 * @param {string} asset: currency or commodity
 * @param {object} assetExtraParams: extra parameters for query
 */
export function getCorrelations(ctx, asset, assetExtraParams = {}) {
  if (asset === "currency") {
    return getCurrencyCorrelations(ctx);
  } else if (asset === "commodity") {
    return getCommodityCorrelations(ctx, assetExtraParams);
  }
}
